import gql from 'graphql-tag';
import { CommentFragment } from '../fragments/comment.fragment';

export const DeleteCommentMutation = gql`
  mutation deleteComment($commentID: ID!) {
    deleteComment(commentID: $commentID) {
      operationResult
      modifiedComment {
        ...CommentFragment
      }
    }
  }
  ${CommentFragment}
`;
